// Local per-device leaderboard. We record results of *completed* matches for the
// human players (bots are ignored). Stored in localStorage until online accounts.

import * as scoreUtil from "core/src/core/score/score-util.js";

export interface StatRow {
  name: string;
  games: number;
  wins: number;
  bestRank: number;
}

const KEY = "ar.stats.v1";

export function getStats(): StatRow[] {
  try {
    const rows: StatRow[] = JSON.parse(localStorage.getItem(KEY) || "[]");
    return rows.sort((a, b) => b.wins - a.wins || b.games - a.games || a.bestRank - b.bestRank);
  } catch {
    return [];
  }
}

function save(rows: StatRow[]): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(rows));
  } catch {
    /* ignore */
  }
}

export function recordMatch(match: any): void {
  try {
    const sorted = scoreUtil.createSortedList(match.getCurrentScore()); // desc by score
    const rankById: Record<string, number> = {};
    sorted.forEach((p: any, i: number) => { rankById[p.id] = i + 1; });

    const humans = match.matchConfig.players.filter((p: any) => p.type === "human");
    if (humans.length === 0) return;

    const rows = (() => {
      try { return JSON.parse(localStorage.getItem(KEY) || "[]") as StatRow[]; } catch { return []; }
    })();

    humans.forEach((h: any) => {
      const rank = rankById[h.id] || 999;
      let row = rows.find((r) => r.name === h.name);
      if (!row) {
        row = { name: h.name, games: 0, wins: 0, bestRank: 999 };
        rows.push(row);
      }
      row.games += 1;
      if (rank === 1) row.wins += 1;
      row.bestRank = Math.min(row.bestRank, rank);
    });
    save(rows);
  } catch {
    /* never let stats break the match flow */
  }
}
